import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  LoanRepartition,
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };

    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<LoanRepartition> = {
      enable: [
        parameters?.loansRepartition?.enable || false,
        Validators.required,
      ],
      amount: [parameters?.loansRepartition?.amount || null],
      monthlyAmount: [parameters?.loansRepartition?.monthlyAmount || null],
      mainResidence: [parameters?.loansRepartition?.mainResidence || false],
      mainResidenceMonthlyAmount: [
        parameters?.loansRepartition?.mainResidenceMonthlyAmount || null,
      ],
      mainResidenceRemainingToPaid: [
        parameters?.loansRepartition?.mainResidenceRemainingToPaid || null,
      ],
      remainingToPaid: [parameters?.loansRepartition?.remainingToPaid || null],
      travaux: [parameters?.loansRepartition?.travaux || false],
      travauxMonthlyAmount: [
        parameters?.loansRepartition?.travauxMonthlyAmount || null,
      ],
      ptz: [parameters?.loansRepartition?.ptz || false],
      ptzMonthlyAmount: [
        parameters?.loansRepartition?.ptzMonthlyAmount || null,
      ],
      car: [parameters?.loansRepartition?.car || false],
      carMonthlyAmount: [
        parameters?.loansRepartition?.carMonthlyAmount || null,
      ],
      student: [parameters?.loansRepartition?.student || false],
      studentMonthlyAmount: [
        parameters?.loansRepartition?.studentMonthlyAmount || null,
      ],
      consumption: [parameters?.loansRepartition?.consumption || false],
      consumptionMonthlyAmount: [
        parameters?.loansRepartition?.consumptionMonthlyAmount || null,
      ],
      realEstate: [parameters?.loansRepartition?.realEstate || false],
      realEstateMonthlyAmount: [
        parameters?.loansRepartition?.realEstateMonthlyAmount || null,
      ],
      investment: [parameters?.loansRepartition?.investment || false],
      investmentMonthlyAmount: [
        parameters?.loansRepartition?.investmentMonthlyAmount || null,
      ],
      other: [parameters?.loansRepartition?.other || false],
      otherMonthlyAmount: [
        parameters?.loansRepartition?.otherMonthlyAmount || null,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value);
    return {
      loansRepartition: {
        ...formValue,
      },
    };
  }
}
